const errorToString = (error, showStack = false) => {
  if (showStack)
    return `${error.stack}`;
  return `${error.name}: ${error.message}`;
};
export default errorToString;
